import styled from 'styled-components'

export const Row = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp4};
  align-items: baseline;
  flex-wrap: wrap;
`
